export default __webpack_public_path__ + "static/media/ilaw-logo.48c97d72.png";